module.exports = __webpack_public_path__ + "media/images/country_flags/sy-c9296626f0eeda7266d24a764f2842d3.png";